import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import Map from '../../../common/Map'
import { OVERVIEW_KEYS } from '../constant'
import { selectCompanyInfoDetail } from '../store/slice'

export const MapItem = () => {
  const data = useSelector(
    selectCompanyInfoDetail((data) => data[OVERVIEW_KEYS.MAP]),
  )

  return (
    <Element className="h100">
      <Map address={data} height={200} />
    </Element>
  )
}
